import JSZip from 'jszip';

import { useDashboardBulkExportStore } from '../useDashboardBulkExportStore';

/**
 * @returns Function to generate and download a zip file of all widget images
 */
export const useGetImageZip = () => {
  const { widgetExports } = useDashboardBulkExportStore();

  const getImageZip = async () => {
    const zip = new JSZip();

    // Track used base names so widgets sharing a title (or all untitled) don't
    // collide on the same zip entry — subsequent duplicates get a numeric suffix.
    const usedNames = new Map<string, number>();

    for (const we of widgetExports) {
      const canvas = await we.exportFn();
      if (canvas === undefined) {
        continue;
      }
      const blob = await new Promise<Blob | null>((resolve) =>
        canvas.toBlob(resolve)
      );
      if (blob) {
        const base = we.filename || we.id;
        const seen = usedNames.get(base) ?? 0;
        usedNames.set(base, seen + 1);
        const name = seen === 0 ? base : `${base}_${seen + 1}`;
        zip.file(`${name}.png`, blob);
      }
    }

    const fullZip = await zip.generateAsync({ type: 'blob' });

    // Download the zip file
    const link = document.createElement('a');
    link.href = URL.createObjectURL(fullZip);
    link.download = `dashboard_images.zip`;
    link.click();
  };

  return { getImageZip };
};
